var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCertonaskeletonimg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 134,
  height: 93,
  fill: "none",
  viewBox: "0 0 134 93"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#D6D6D6",
  d: "M.5.5h133v92H.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D6D6D6",
  d: "M51.893 18 20 73.496h24.847L76.748 18z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6E6E6",
  d: "M82.65 18 50.748 73.496h14.69L97.377 18z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "M113.883 18h-10.614L71.377 73.496h10.604z"
})));
export default SvgCertonaskeletonimg;